export default "__VITE_ASSET__Xe78RltW__"